module.exports = __webpack_public_path__ + "static/photo3-219da6b430c95b2ba75a0d3a18fe25f6.png";